import React from 'react';
import { QueryProvider } from './QueryProvider';

export const UsersProviders = ({ children }: any) => {
    return (
        <QueryProvider>
            {children}
        </QueryProvider>
    );
}